enum PROFILE_TIERS {
  basic = 'basic',
  branded = 'branded',
  platinum = 'platinum',
}

export default PROFILE_TIERS;
